<template>
  <img class="image" :src="url" :alt="alt" />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'

export interface ImageProps {
  url: string
  alt?: string
}

const props = defineProps<ImageProps>()
const { url } = toRefs(props)
</script>

<style lang="scss" scoped>
.image {
  max-height: 250px;
  max-width: 380px;
}
</style>
